import { Users } from '@good/icons';
import { Center, SegmentedControl, Text } from '@good/ui/core';
import _ from 'lodash';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IRootDispatch, IRootState } from 'stores/rematch/root-store';
import { ROSTER_DISPLAY_MODE } from '../bookings-roster-view/components/roster-common-enums';

export const BookingsViewToolbarRosterModeControl = () => {
  const value = useSelector((state: IRootState) => state.bookingsStore.rosterMode);
  const dispatch = useDispatch<IRootDispatch>();

  return (
    <SegmentedControl
      variant='default'
      value={value}
      data={[
        {
          label: (
            <Center style={{ gap: 10 }} px='xs'>
              <Users />
              <Text inherit span fw={550}>
                All
              </Text>
            </Center>
          ),
          value: ROSTER_DISPLAY_MODE.ALL,
        },
        {
          label: (
            <Center style={{ gap: 10 }} px='xs'>
              <Text inherit span fw={550}>
                Team members
              </Text>
            </Center>
          ),
          value: ROSTER_DISPLAY_MODE.TEAM_MEMBERS,
        },
        {
          label: (
            <Center style={{ gap: 10 }} px='xs'>
              <Text inherit span fw={550}>
                Customers
              </Text>
            </Center>
          ),
          value: ROSTER_DISPLAY_MODE.CUSTOMERS,
        },
      ]}
      onChange={(value) => dispatch.bookingsStore.setRosterDisplayMode(value as ROSTER_DISPLAY_MODE)}
    />
  );
};
